<div class="label">
  <div layout layout-align-items-center>
    @if (hasIcon) {
      <rt-icon name="upgrade" size="small-x" margin-right-small-xx />
    }
    <ng-content />
  </div>
</div>
